import { render } from "./AdaptyIntegrationSettings.vue?vue&type=template&id=226e908c"
import script from "./AdaptyIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./AdaptyIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__